export interface ComisionBancaria {
  comisionId: number;
  bancoId: number;
  codigoPais: string;
  tipoCuenta: TipoCuenta;
  tipoOperacion: TipoOperacion;
  tipoValor: TipoValor;
  porcentaje?: number;
  valorFijo?: number;
  activo: number;
  responsableEmail: string;
  createdAt: Date;
  updatedAt: Date;
  banco?: any;
}

export enum TipoOperacion {
  TRANSFERENCIA_ENVIADA_OTROS_BANCOS_PERSONA = 'transferencia_enviada_otros_bancos_persona',
  TRANSFERENCIA_ENVIADA_OTROS_BANCOS_EMPRESA = 'transferencia_enviada_otros_bancos_empresa',
  TRANSFERENCIA_ENVIADA_MISMO_BANCO_PERSONA = 'transferencia_enviada_mismo_banco_persona',
  TRANSFERENCIA_ENVIADA_MISMO_BANCO_EMPRESA = 'transferencia_enviada_mismo_banco_empresa',
  TRANSFERENCIA_RECIBIDA_OTRO_BANCO_PERSONA = 'transferencia_recibida_otro_banco_persona',
  TRANSFERENCIA_RECIBIDA_OTRO_BANCO_EMPRESA = 'transferencia_recibida_otro_banco_empresa',
  TRANSFERENCIA_RECIBIDA_MISMO_BANCO_PERSONA = 'transferencia_recibida_mismo_banco_persona',
  TRANSFERENCIA_RECIBIDA_MISMO_BANCO_EMPRESA = 'transferencia_recibida_mismo_banco_empresa',
  PAGO_MOVIL_RECIBIDO = 'pago_movil_recibido',
  PAGO_MOVIL_ENVIADO = 'pago_movil_enviado',
  TRANSFERENCIA_MISMO_TITULAR = 'transferencia_mismo_titular',
}

export enum TipoValor {
  PORCENTAJE = 'porcentaje',
  FIJO = 'fijo',
}

export enum TipoCuenta {
  PERSONAL = 'personal',
  JURIDICA = 'juridica',
}

export interface CreateComisionDto {
  bancoId: number;
  codigoPais: string;
  tipoCuenta: TipoCuenta;
  tipoOperacion: TipoOperacion;
  tipoValor: TipoValor;
  porcentaje?: number | null;
  valorFijo?: number | null;
}

export interface UpdateComisionDto {
  tipoCuenta?: TipoCuenta;
  tipoValor?: TipoValor;
  porcentaje?: number | null;
  valorFijo?: number | null;
}

export interface ComisionFilterDto {
  bancoId?: number;
  tipoCuenta?: TipoCuenta;
  tipoOperacion?: TipoOperacion;
  activo?: boolean;
}

export interface PaginationDto {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}

export interface PaginationMeta {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  from: number;
  to: number;
}

export interface ComisionPaginatedResponse {
  data: ComisionBancaria[];
  meta: PaginationMeta;
}
